export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_parent-alert-system-9/artifacts/us1lxhvh_%D8%B5%D9%88%D8%B1%D8%A9%20ChatGPT%2029%20%D8%B3%D8%A8%D8%AA%D9%85%D8%A8%D8%B1%202026%D8%8C%2005_34_01%20%D9%85.png";

export const Logo = ({ className = "h-10", withText = false }) => (
  <div className="flex items-center gap-2" data-testid="app-logo">
    <img src={LOGO_URL} alt="معاكم" className={`${className} w-auto object-contain`} />
    {withText && (
      <span className="text-xl font-extrabold text-emerald-900">معاكم</span>
    )}
  </div>
);

export default Logo;
